import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import I18 from "../../_components/atoms/i18";
import Sidebar from "../../_components/sidebar.component";
import { SidebarDirectMessagesSubMenu } from "../../_components/sidebar/direct-messages-submenu.component";
import DirectChatPage from "../direct-chat.page";
import DirectMessageSidebarComponent from "./direct-message-sidebar.component";

export const DIRECT_MESSAGE_PAGE_ROUTE = "/direct-message/:userId";
export const getDirectMessagePageRoute = (userId) =>
  `/direct-message/${userId}`;

function DirectMessageComponent() {
  const { userId } = useParams();
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1201);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      <div className="AppContainer">
        <div className="sidebar_left">
          <Sidebar />
        </div>
        <div className="main">
          {userId !== "users" ? (
            <DirectChatPage />
          ) : isMobile ? (
            <>
              <SidebarDirectMessagesSubMenu />
            </>
          ) : (
            <div className="h-screen theme-bg-surface flex items-center justify-center">
              <div className="theme-text-subtitle-1 text-2xl ">
                <i className="fi fi-rr-comment-alt flex items-center justify-center text-6xl" />
                <div className="theme-text-subtitle-1 text-xl flex items-center mt-2 justify-center">
                  <I18>Start a conversation</I18>
                </div>
              </div>
            </div>
          )}
        </div>
        {isMobile ? <></> : <DirectMessageSidebarComponent />}
      </div>
    </div>
  );
}
const DirectMessagePage = DirectMessageComponent;
export default DirectMessagePage;
